module.exports = __webpack_public_path__ + "static/media/userAvatarWhite.be92f1d4.svg";